<template>
	<div :id="id" class="c-search-section-news">
		<div
			:class="[
				'grid gap-layout-gutter',
				'grid-cols-1 >=768:grid-cols-2 >=1024:grid-cols-3',
			]"
		>
			<ContentCard
				v-for="(item, index) in items"
				:key="`news-${index}`"
				:title="item.title || item.name"
				:teaser="item.teaser"
				:link="{ url: item.url, target: item.target }"
				:image="{
					...(item.image || {}),
					aspectRatio: 416 / 234,
				}"
				:has-external-outbound-redirect="
					item.hasExternalOutboundRedirect
				"
				:external-outbound-redirect="item.externalOutboundRedirect"
			>
				<template #before>
					<div
						class="font-darker-grotesque font-semibold mb-6"
						v-text="formatDate(item.newsDate)"
					></div>
				</template>
			</ContentCard>
		</div>
	</div>
</template>

<script>
import ContentCard from '~/components/shared/ContentCard';

export default {
	name: 'SearchSectionNews',
	components: { ContentCard },

	props: {
		id: {
			type: String,
			required: true,
		},

		items: {
			type: Array,
			default: () => [],
		},
	},

	methods: {
		formatDate(dateString) {
			const date = new Date(dateString);
			const day = `0${date.getDate()}`.slice(-2);
			const month = `0${date.getMonth() + 1}`.slice(-2);
			const year = date.getFullYear();
			return `${day}.${month}.${year}`;
		},
	},
};
</script>
